import { isGqlError } from '@conteg/ui';

/**
 * Reads `extensions.errorCode` from the first GraphQL error, ignoring the difference between the
 * spellings a code can arrive in (`TwoFactorNotVerified`, `TWO_FACTOR_NOT_VERIFIED`,
 * `twoFactorNotVerified`). The gateway names its codes with a C# enum and the value passes through the
 * shared error filter and the GraphQL result formatter on the way out, so matching on one exact casing
 * would make the message silently fall back to the generic one.
 *
 * Prefer `resolveGqlErrorMessageKey` where the codes come from a schema enum and the casing is known.
 */
export const matchesGqlErrorCode = (error: unknown, code: string): boolean => {
  const actual = readGqlErrorCode(error);
  return actual !== undefined && normalize(actual) === normalize(code);
};

export const readGqlErrorCode = (error: unknown): string | undefined => {
  if (!isGqlError(error)) return undefined;
  const errors = error.errors as
    | Array<{ extensions?: { errorCode?: string } }>
    | undefined;
  return errors?.[0]?.extensions?.errorCode;
};

const normalize = (code: string) => code.replace(/_/g, '').toLowerCase();
